import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVGrid, EVTypography, EVChip, EVCheckbox, makeStyles,
} from 'lib/components';

const useStyles = makeStyles((theme) => {
  const chipColors = [
    { background: theme.evPalette.ocean[200], color: theme.evPalette.ocean[800] },
    { background: theme.evPalette.mango[100], color: theme.evPalette.mango[900] },
    { background: theme.evPalette.lime[100], color: theme.evPalette.lime[900] },
    { background: theme.evPalette.raspberry[100], color: theme.evPalette.raspberry[900] },
  ];

  return {
    structureItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      padding: theme.spacing(1.5, 0),
      borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
      '&:last-of-type': {
        borderBottom: 'none',
      },
    },
    structureItemContent: {
      flex: 1,
      minWidth: 0,
    },
    buildingIdRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 4,
    },
    buildingIdLabel: {
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '18px',
      textTransform: 'uppercase',
      color: theme.evPalette.charcoal[800],
    },
    buildingIdChip: ({ index }) => ({
      ...chipColors[index % chipColors.length],
      borderRadius: 12,
      alignItems: 'center',
      height: 18,
      padding: '2px 8px',
      minWidth: 23,
      margin: '0 6px',
      '& > span': { padding: 0 },
    }),
    structureAddress: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: theme.evPalette.charcoal[900],
    },
    structureCheckbox: {
      flexShrink: 0,
      '& .myev-MuiCheckbox-colorPrimary.Mui-checked': {
        color: theme.evPalette.ocean[600],
      },
    },
  };
});

function SitemapApprovalStructureItem({
  buildingId,
  address,
  index,
  checked,
  onToggle,
}) {
  const classes = useStyles({ index });

  return (
    <EVGrid className={classes.structureItem} container wrap="nowrap" alignItems="center">
      <EVGrid className={classes.structureItemContent}>
        <EVGrid className={classes.buildingIdRow}>
          <EVTypography className={classes.buildingIdLabel}>Building ID</EVTypography>
          <EVChip label={buildingId} className={classes.buildingIdChip} />
        </EVGrid>
        <EVTypography className={classes.structureAddress}>{address}</EVTypography>
      </EVGrid>
      <EVCheckbox
        className={classes.structureCheckbox}
        color="primary"
        checked={checked}
        onChange={onToggle}
        inputProps={{ 'aria-label': `Select building ${buildingId}` }}
      />
    </EVGrid>
  );
}

SitemapApprovalStructureItem.propTypes = {
  buildingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  address: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SitemapApprovalStructureItem;
